export const formatMetrics = (startTime: number, response: Response) => ({
  duration: Date.now() - startTime,
  status: response.status,
  response,
});
